import { render, staticRenderFns } from "./CommentsAction.vue?vue&type=template&id=f6d0157a&"
import script from "./CommentsAction.vue?vue&type=script&lang=js&"
export * from "./CommentsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports